window.initSwiper = function (sectionId, productId) {
  var swiper5 = new Swiper(".slider-card-" + sectionId + "-" + productId, {
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
    grid: {
      rows: 1,
      fill: 'row',
    },
    navigation: {
      nextEl: '.swiper-next-' + sectionId + "-" + productId,
      prevEl: '.swiper-prev-' + sectionId + "-" + productId,
    },
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.swiper-wrapper');

  sliders.forEach(function (slider) {
    const sectionId = slider.getAttribute('data-section-id');
    const productId = slider.getAttribute('data-product-id');

    if (sectionId && productId) {
      window.initSwiper(sectionId, productId);
    }
  });
});

// menu toggler js
document.querySelector("button.navbar-toggle")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer").classList.add("active");
  document.querySelector(".mm-fullscreen-bg").classList.add("active");
  document.body.classList.add("ov-hidden");
  const drawer = document.querySelector('.menu-drawer');
  trapFocus(drawer);
  const escHandler = (evt) => {
    if (evt.code === 'Escape') {
      document.querySelector(".menu-drawer")?.classList.remove("active");
      document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
      document.body.classList.remove("ov-hidden");
      const drawerbtn = document.querySelector('button.navbar-toggle');
      removeTrapFocus(drawerbtn);
      document.removeEventListener('keyup', escHandler); // Cleanup listener
    }
  };
  document.addEventListener('keyup', escHandler);
});

// Menu drawer close
document.querySelector(".menu-drawer-close")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
  const drawerbtn = document.querySelector('button.navbar-toggle');
  removeTrapFocus(drawerbtn);
});

// Filter button
document.querySelector("button.filter-button")?.addEventListener("click", function() {
  document.querySelector(".filter-sidebar")?.classList.add("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.add("active");
  document.body.classList.add("ov-hidden");
  const drawer = document.querySelector('.filter-sidebar');
  trapFocus(drawer);
  const escHandler = (evt) => {
    if (evt.code === 'Escape') {
      document.querySelector(".filter-sidebar")?.classList.remove("active");
      document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
      document.body.classList.remove("ov-hidden");
      const drawerbtn = document.querySelector('button.filter-button');
      removeTrapFocus(drawerbtn);
      document.removeEventListener('keyup', escHandler); // Cleanup listener
    }
  };
  document.addEventListener('keyup', escHandler);
});

document.querySelector("button.close-filter-sidebar")?.addEventListener("click", function() {
  document.querySelector(".filter-sidebar")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
  const drawerbtn = document.querySelector('button.filter-button');
  removeTrapFocus(drawerbtn);
});

// Body background click
document.querySelector(".mm-fullscreen-bg")?.addEventListener("click", function() {
  document.querySelector(".menu-drawer")?.classList.remove("active");
  document.querySelector(".filter-sidebar")?.classList.remove("active");
  document.querySelector(".mm-fullscreen-bg")?.classList.remove("active");
  document.body.classList.remove("ov-hidden");
});

// Enable/disable button based on checkbox
document.querySelector(".read-agree")?.addEventListener("click", function() {
  const checkbox = document.querySelector(".create-checkbox");
  const button = document.querySelector(".create");
  if (checkbox?.checked) {
    button?.removeAttribute("disabled");
  } else {
    button?.setAttribute("disabled", "disabled");
  }
});

// Function to change the product image based on the selected color
function changeProductImage(event) {
  const selectedColor = event.target;
  const productItem = selectedColor.closest('.single-product-wrap');
  const productImage = productItem.querySelector('img');
  const newImageUrl = selectedColor.getAttribute('data-image');
  productImage.srcset = newImageUrl;

  // Reset swiper to first slide when color changes
  const sectionId = productItem.querySelector('.swiper-wrapper')?.getAttribute('data-section-id');
  const productId = productItem.querySelector('.swiper-wrapper')?.getAttribute('data-product-id');

  if (sectionId && productId) {
    const swiperEl = productItem.querySelector('.slider-card-' + sectionId + '-' + productId);
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.slideTo(0); // Reset to first image
    }
  }
}

// Add event listeners to all color options
document.querySelectorAll('.pr-gr-option input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', changeProductImage);
});

// Level 1 menu arrow click
document.addEventListener("click", function(e) {
  if (e.target.closest(".menu-arrow")) {
    const arrow = e.target.closest(".menu-arrow");
    const menuLink = arrow.closest("li");
    const mainMenu = menuLink.querySelector(".menu-dropdown");

    if (menuLink.classList.contains("open")) {
      menuLink.classList.remove("open");
      document.querySelector(".menu-content")?.classList.remove("open-level-1");
    } else {
      mainMenu?.classList.add("open");
      menuLink.classList.add("open");
      document.querySelector(".menu-content")?.classList.add("open-level-1");
    }

    e.stopPropagation();
    // Prevent default only if not inside <summary>
    if (!arrow.closest("summary")) {
      e.preventDefault();
    }
  }
});

// Level 2 submenu arrow click
document.addEventListener("click", function(e) {
  if (e.target.closest(".menu-arrow-sub")) {
    const arrow = e.target.closest(".menu-arrow-sub");
    const menuLink = arrow.closest("li");
    const mainMenu = menuLink.querySelector(".supmenu-dropdown");

    if (menuLink.classList.contains("open")) {
      menuLink.classList.remove("open");
      document.querySelector(".menu-content")?.classList.remove("open-level-2");
    } else {
      mainMenu?.classList.add("open");
      menuLink.classList.add("open");
      document.querySelector(".menu-content")?.classList.add("open-level-2");
    }

    e.stopPropagation();
    // Prevent default only if not inside <summary>
    if (!arrow.closest("summary")) {
      e.preventDefault();
    }
  }
});

// Back button in level 1 menu
document.addEventListener("click", function(e) {
  if (e.target.closest(".back-menu")) {
    const backMenu = e.target.closest(".menu-dropdown");
    setTimeout(() => {
      backMenu?.classList.remove("open");
    }, 500);
    document.querySelectorAll(".menu-link").forEach(el => el.classList.remove("open"));
    document.querySelector(".menu-content")?.classList.remove("open-level-1");

    e.stopPropagation();
    e.preventDefault();
  }
});

// Back button in level 2 submenu
document.addEventListener("click", function(e) {
  if (e.target.closest(".back-menu-sub")) {
    const backMenu = e.target.closest(".supmenu-dropdown");
    setTimeout(() => {
      backMenu?.classList.remove("open");
    }, 500);
    document.querySelectorAll(".singlemenu-li").forEach(el => el.classList.remove("open"));
    document.querySelector(".menu-content")?.classList.remove("open-level-2");

    e.stopPropagation();
    e.preventDefault();
  }
});

// Function to open modal
function openModal(modalId, focusElement) {
  this.focusElement = focusElement;
  const modal = document.getElementById(modalId);
  modal.classList.add('show');
  document.body.classList.add('ov-hidden');
  const modals = document.querySelector('.modal.show');
  trapFocus(modals);
}

// Function to close modal
function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  modal.classList.remove('show');
  document.body.classList.remove('ov-hidden');
  removeTrapFocus(this.focusElement);
}
// Add event listeners to buttons to open modals
document.addEventListener('click', function (e) {
  const button = e.target.closest('.modal-button');
  if (!button) return;
  const modalId = button.getAttribute('data-modal');
  openModal(modalId, button);
  const escHandler = (evt) => {
    if (evt.code === 'Escape') {
      closeModal(modalId);
      document.removeEventListener('keyup', escHandler);
    }
  };
  document.addEventListener('keyup', escHandler);
});
// Add event listeners to close buttons within modals
document.querySelectorAll('.close').forEach(function (btn) {
  btn.addEventListener('click', function () {
      const modalId = btn.getAttribute('data-modal');
      closeModal(modalId);
  });
});

// Add event listener to window to close modals when clicking outside
window.addEventListener('click', function (event) {
  const modals = document.querySelectorAll('.modal');
  modals.forEach(function (modal) {
    if (event.target == modal) {
      modal.classList.remove('show');
      document.body.classList.remove('ov-hidden');
      removeTrapFocus(this.focusElement);
    }
  });
});


// Tab

const tabContainers = document.querySelectorAll('.tab-container');

tabContainers.forEach(container => {
  const tabs = container.querySelectorAll('.tab-button');
  const contents = container.querySelectorAll('.tab-pane');

  container.querySelector('.nav-tabs').addEventListener('click', function (event) {
    const tabButton = event.target.closest('.tab-button'); // span → button
    if (!tabButton) return;

    const tabId = tabButton.getAttribute('tab-id');

    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => {
        content.classList.remove('active');
        content.style.display = 'none';
    });

    tabButton.classList.add('active');
    const activeContent = container.querySelector('#' + tabId);
    activeContent.style.display = 'block';
    setTimeout(() => {
        activeContent.classList.add('active');
    }, 10);
  });


  // Activate the first tab and content by default
  tabs[0].classList.add('active');
  const firstContent = contents[0];
  firstContent.style.display = 'block';
  setTimeout(() => {
      firstContent.classList.add('active');
  }, 10);
});

// collapse

const dropdownButtons = document.querySelectorAll('.dropdown-btn');

dropdownButtons.forEach(button => {
    button.addEventListener('click', function() {
        const targetClass = this.getAttribute('data-target');
        const dropdownContents = document.querySelectorAll(targetClass);

        dropdownContents.forEach(dropdownContent => {
            if (dropdownContent.classList.contains("show")) {
                // Close the dropdown
                dropdownContent.style.height = dropdownContent.scrollHeight + 'px';
                dropdownContent.offsetHeight; // force repaint to ensure the height transition happens
                dropdownContent.style.height = '0px';

                dropdownContent.addEventListener('transitionend', function() {
                    // After transition, remove the inline height style
                    if (!dropdownContent.classList.contains('show')) {
                        dropdownContent.style.removeProperty('height');
                    }
                }, { once: true });

                dropdownContent.classList.remove('show');
                button.classList.remove('show');
            } else {
                // Open the dropdown
                dropdownContent.style.height = dropdownContent.scrollHeight + 'px';

                dropdownContent.addEventListener('transitionend', function() {
                    // After transition, set height to auto
                    if (dropdownContent.classList.contains('show')) {
                        dropdownContent.style.height = 'auto';
                    }
                }, { once: true });

                dropdownContent.classList.add('show');
                button.classList.add('show');
            }
        });
    });

    // Set the initial state of the dropdown if it's already open
    const targetClass = button.getAttribute('data-target');
    const dropdownContents = document.querySelectorAll(targetClass);

    dropdownContents.forEach(dropdownContent => {
        if (dropdownContent.classList.contains("show")) {
            dropdownContent.style.height = dropdownContent.scrollHeight + 'px';
            dropdownContent.style.height = 'auto';
        }
    });
});


// accordion

const accordionButtons = document.querySelectorAll('.accordian-btn');
const accordionContents = document.querySelectorAll('.accordian-content');

accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const targetContent = document.querySelector(targetId);

        // Collapse all accordion contents
        accordionContents.forEach(content => {
            if (content !== targetContent) {
                content.style.height = '0px';
                content.classList.remove('show');
            }
        });

        // Remove 'show' class from all buttons
        accordionButtons.forEach(btn => {
            if (btn !== button) {
                btn.classList.remove('show');
            }
        });

        // Toggle the clicked accordion content
        if (targetContent) {
            if (targetContent.classList.contains('show')) {
                targetContent.style.height = '0px';
                targetContent.classList.remove('show');
                button.classList.remove('show');
            } else {
                targetContent.style.height = targetContent.scrollHeight + 'px';
                targetContent.classList.add('show');
                button.classList.add('show');
            }
        }
    });

    // Set initial height if the accordion content is already shown
    const targetId = button.getAttribute('data-target');
    const accordionContent = document.querySelector(targetId);
    if (accordionContent && accordionContent.classList.contains('show')) {
        accordionContent.style.height = accordionContent.scrollHeight + 'px';
    }
});


const getScrollTop = (element) => {
  let offsetTop = 0
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop
    }
  } while ((element = element.offsetParent))
  return offsetTop
}
const portView = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;
  return windowBottom >= getScrollTop(element);
}


if ('.week-countdown') {
  document.querySelectorAll('.week-countdown').forEach(function (el) {
  var endDate = el.getAttribute('data-id');
  var endDate = el.getAttribute('data-enddate');
  var parsedDate = new Date(endDate);

  if (!isNaN(parsedDate)) {
  function updateCountdown() {
    var now = new Date().getTime();
    var distance = parsedDate - now;

    if (distance <= 0) {
      el.style.display = 'none';
      clearInterval(interval);
      return;
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    el.querySelector('ul').innerHTML = `
      <li><div class="timer-block"><div class="timer-info"><h6 class='m-0'>${days}</h6> <span>${el.dataset.dayTitle || 'Day'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><h6 class='m-0'>${hours}</h6> <span>${el.dataset.hourTitle || 'Hour'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><h6 class='m-0'>${minutes}</h6> <span>${el.dataset.minuteTitle || 'Min'}</span></div></div></li>
      <li><div class="timer-block"><div class="timer-info"><h6 class='m-0'>${seconds}</h6> <span>${el.dataset.secondTitle || 'Sec'}</span></div></div></li>
  `;
  }
  updateCountdown(); // Initial call
  var interval = setInterval(updateCountdown, 1000);
  }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const videoBackgrounds = document.querySelectorAll('video-background-component');

  videoBackgrounds.forEach(videoBackground => {
    const videoSources = videoBackground.querySelectorAll('[data-video-source]');
    const videoElement = videoBackground.querySelector('video');

    if (!videoSources.length || !videoElement) return;

    videoSources.forEach(source => {
      const videoSource = source.dataset.videoSource;
      if (videoSource) {
        source.setAttribute('src', videoSource);
      }
    });

    videoElement.load();
  });
});

document.querySelectorAll("video img").forEach(img => {
  if (!img.hasAttribute("alt")) {
    img.setAttribute("alt", "Oversize heavy weight t-shirt video preview");
  }
});

